import { routesAndPagesMap } from "Common/routingUtils";
import React from "react";
export default function Switcher({ routingPageKey, getterName, defaultValue, ...other }) {
    if (!routingPageKey)
        return defaultValue;
    const getter = getterName === "getPageComponent" ? routesAndPagesMap.getPageComponent : undefined;
    const Component = getter ? getter(routingPageKey) : undefined;
    return Component ? React.createElement(Component, { ...other }) : defaultValue;
}
Switcher.defaultProps = {
    defaultValue: null
};
